import { CARGO_STAGES } from "src/app/Cargo/types";

// Re-export for consumers that import from this module
export { CARGO_STAGES };

/**
 * Route paths for JSON Forms pages.
 */
export const JSON_FORMS_ROUTES = {
  CARGO_CLAIM_INTAKE_FORM: "/cargo/json-forms/claim-intake-form",
  CARGO_CONTINUE_FORM: "/cargo/json-forms/claim-intake-form/continue",
} as const;

/**
 * Form data keys for Cargo stages in the jsonFormsSlice.
 * Used to key form data and validation errors by `{lob}_{stage}`.
 */
export const CARGO_STAGE_KEYS = {
  STAGE1: "cargo_stage1",
  STAGE2: "cargo_stage2",
  STAGE3: "cargo_stage3",
} as const;

/**
 * Maps a submitted stage to the next stage key for form loading.
 * When a claim has `submittedStage: STAGE1`, the user should continue with Stage 2, etc.
 */
export const NEXT_STAGE_MAP: Record<string, string> = {
  [CARGO_STAGES.STAGE1]: CARGO_STAGE_KEYS.STAGE2,
  [CARGO_STAGES.STAGE2]: CARGO_STAGE_KEYS.STAGE3,
} as const;
